import { IApplication } from './application';
import { ITenantDTO } from '../services/tenant.service';

export class Tenant {
  authenticationProviders: string;
  name: string;
  description?: string;
  id: string;
  applications?: IApplication[];

  constructor(tenantDTO?: ITenantDTO) {
    if (tenantDTO) {
      Object.assign(this, tenantDTO);
    }
  }

  hasAllowedProvider(allowedProviders: Array<string>): boolean {
    if (!this.authenticationProviders) {
      return false;
    }
    return allowedProviders.includes(this.authenticationProviders);
  }
}
